var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJuno(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "39px",
    height: "39px",
    viewBox: "0 0 39 39",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon/services/junodownload") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/services/junodownload",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#97B43D",
    fillRule: "nonzero",
    cx: 19.5,
    cy: 19.5,
    r: 19.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.260274,17.6065401 L27.260274,9 L28,9 L28,25.3569464 L27.260274,25.3569464 L27.260274,21.4592242 C26.6260573,23.860607 24.8370369,25.6047789 22.6986301,25.6047789 C20.0205194,25.6047789 17.890411,22.8690963 17.890411,19.5328821 C17.890411,16.1966679 20.0205194,13.4609854 22.6986301,13.4609854 C24.8370369,13.4609854 26.6260573,15.2051573 27.260274,17.6065401 Z M12.377138,13.5235016 L15.3748064,13.5235016 C15.4852634,13.5235016 15.5748064,13.6130447 15.5748064,13.7235016 L15.5748064,27.2125968 C15.5748064,28.7520371 14.3268435,30 12.7874032,30 L10.2,30 C10.0895431,30 10,29.9104569 10,29.8 L10,27.3192758 C10,27.2089986 10.0892627,27.1195301 10.1995397,27.1192763 L11.1428204,27.1171052 C11.6872404,27.1158522 12.1284901,26.6752438 12.1305349,26.1308262 L12.1771394,13.7227504 C12.1775531,13.6125875 12.2669743,13.5235016 12.377138,13.5235016 Z M12.0685663,9.20350058 C12.0685663,9.09312327 12.157985,9.00361325 12.2683623,9.00350068 L15.5006921,9.00020418 C15.5007601,9.00020411 15.5008281,9.00020407 15.5008961,9.00020407 C15.6113531,9.00020407 15.7008961,9.08974712 15.7008961,9.20020407 L15.7008961,11.9558578 C15.7008961,12.0663147 15.6113531,12.1558578 15.5008961,12.1558578 L12.2685663,12.1558578 C12.1581093,12.1558578 12.0685663,12.0663147 12.0685663,11.9558578 L12.0685663,9.20350058 Z M22.6986301,24.8612813 C24.9229923,24.8612813 26.7671233,22.4928775 26.7671233,19.5328821 C26.7671233,16.5728867 24.9229923,14.2044829 22.6986301,14.2044829 C20.474268,14.2044829 18.630137,16.5728867 18.630137,19.5328821 C18.630137,22.4928775 20.474268,24.8612813 22.6986301,24.8612813 Z",
    id: "Combined-Shape",
    fill: "#FFFFFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJuno);
export default __webpack_public_path__ + "static/media/juno.5a638119c1e30a55674df2e11c347e22.svg";
export { ForwardRef as ReactComponent };